// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6d6f3cfa","703":"38360a7e","787":"b27abd32"}[chunkId] + ".chunk.js";
};